export const DATE_KEY_FORMAT = 'yyyy-MM-dd';
export const DATE_DISPLAY_FORMAT = 'E, L/dd';

export const TIME_KEY_FORMAT = 'HH:mm:ss';
export const TIME_DISPLAY_FORMAT = 'h:mmaaa';

export const DATE_TIME_DISPLAY_FORMAT = `eee MMM dd ${TIME_DISPLAY_FORMAT}`;
export const DATE_DISPLAY_FORMAT_ALT = 'eee MMM dd';

export const DATE_DISPLAY_FORMAT_NO_COMMA = 'E L/d';
export const DATE_DISPLAY_FORMAT_NO_COMMA_WITH_YEAR = 'E L/d/yy';
